import React from 'react';

const createToastId = (prefix) => `${prefix}-${Date.now()}-${Math.random()}`;

export const maxSelectFile = (event, toast) => {
	let files = event.target.files;

	if (files.length > 10) {
		const msg = 'Only 10 files can be uploaded at a time';
		toast.error(msg, { toastId: createToastId('max-files') });

		return false;
	}

	return true;
};

export const checkMimeType = (event, toast, modelDefId) => {
	let files = event.target.files;
	let err = [];
	const types = ['application/pdf'];
	if (modelDefId !== 3) { types.unshift('image/png', 'image/jpeg', 'image/jpg'); }

	for (var x = 0; x < files.length; x++) {
		if (types.every(type => files[x].type !== type)) {
			err.push(files[x].name + ' of type \'' + files[x].type + '\' is not a supported format');
		}
	}

	if (err.length > 0) {
		for (var i = 0; i < err.length; i++) {
			toast.error(err[i], { toastId: createToastId(`mime-${i}`) });
		}

		return false;
	}

	return true;
};

export const checkFileSize = (event, toast) => {
	let files = event.target.files;
	var size = 10 * 1024 * 1024;
	let err = "";

	for (var x = 0; x < files.length; x++) {
		if (files[x].size > size) {
			err += files[x].name + ' is too large, please pick a smaller file\n';
		}
	}

	if (err !== '') {
		toast.error(err, { toastId: createToastId('file-size') });

		return false;
	}

	return true;
};

const showUploadResultToast = (toast, uploadedFiles, rejectedFiles) => {
	const uploadedCount = Array.isArray(uploadedFiles) ? uploadedFiles.length : 0;
	const hasRejectedFiles = Array.isArray(rejectedFiles) && rejectedFiles.length > 0;

	if (uploadedCount > 0) {
		toast.success(`${uploadedCount} file(s) uploaded successfully.`, {
			toastId: createToastId('upload-success')
		});
	}

	if (hasRejectedFiles) {
		window.setTimeout(() => {
			toast.error(
				<div>
					<div><strong>File(s) could not be uploaded:</strong></div>
					{rejectedFiles.map((item, index) => (
						<div key={index}>
							{item.errorMessage || `File "${item.fileName}" could not be uploaded.`}
						</div>
					))}
				</div>,
				{
					toastId: createToastId('upload-error')
				}
			);
		}, 0);
	}
};

export const fileUpload = (that, event, modelDefId, toast, httpPost, onProgressStart, onProgressEnd, onUploadProgress, onSuccess) => {
	const formData = new FormData();
	const files = Array.from(event.target.files);

	for (var x = 0; x < files.length; x++) {
		const fileOriginal = files[x];
		var filename = fileOriginal.name.replace(/[^\w\.]/gi, '');
		var file = new File([fileOriginal], filename, { type: fileOriginal.type });
		files[x] = file;
	}

	if (maxSelectFile(event, toast) && checkMimeType(event, toast, modelDefId) && checkFileSize(event, toast)) {
		that.state.selectedFiles = files;
	} else {
		event.target.value = null;
		onProgressEnd();
		return;
	}

	that.state.selectedFiles.forEach((file, i) => {
		formData.append(i, file);
	});

	formData.append("modelDefId", modelDefId);

	const token = localStorage.token;
	const headers = {
		'Content-Type': 'application/json',
		'Authorization': `Bearer ${token}`
	};

	onProgressStart();

	httpPost("/api/nonmappedinvoices/upload", formData, {
		headers: headers,
		onUploadProgress: onUploadProgress,
	}).then((response) => {
		onProgressEnd();

		const data = response?.data || {};
		const uploadedFiles = data.uploadedFiles || [];
		const rejectedFiles = data.rejectedFiles || [];
		const message = data.message || 'Upload successfully';

		showUploadResultToast(toast, uploadedFiles, rejectedFiles);

		if (uploadedFiles.length === 0 && rejectedFiles.length === 0) {
			toast.success(message, { toastId: createToastId('upload-message') });
		}

		onSuccess();
	}).catch((error) => {
		onProgressEnd();

		const responseData = error?.response?.data;
		const rejectedFiles = responseData?.rejectedFiles;
		const message = responseData?.message || 'Upload failed';

		if (Array.isArray(rejectedFiles) && rejectedFiles.length > 0) {
			showUploadResultToast(toast, [], rejectedFiles);
		} else {
			toast.error(message, { toastId: createToastId('upload-failed') });
		}
	});

	event.target.value = null;
};

export const fileAttchmentUpload = (that, event, modelDefId, invoiceDocumentId, toast, httpPost, onProgressStart, onProgressEnd, onUploadProgress, onSuccess) => {
	const formData = new FormData();
	const files = Array.from(event.target.files);

	for (var x = 0; x < files.length; x++) {
		const fileOriginal = files[x];
		var filename = fileOriginal.name.replace(/[^\w\.]/gi, '');
		var file = new File([fileOriginal], filename, { type: fileOriginal.type });
		files[x] = file;
	}

	if (maxSelectFile(event, toast) && checkMimeType(event, toast) && checkFileSize(event, toast)) {
		that.state.selectedFiles = files;
	} else {
		event.target.value = null;
		return;
	}

	that.state.selectedFiles.forEach((file, i) => {
		formData.append(i, file);
	});

	formData.append("modelDefId", modelDefId);
	formData.append("invoiceDocumentId", invoiceDocumentId);

	const token = localStorage.token;
	const headers = {
		'Content-Type': 'application/json',
		'Authorization': `Bearer ${token}`
	};

	onProgressStart();

	httpPost("/api/invoiceAttachment/upload", formData, {
		headers: headers,
		onUploadProgress: onUploadProgress,
	}).then((response) => {
		onProgressEnd();

		toast.success('Uploaded Successfully', { toastId: createToastId('attachment-success') });

		onSuccess();
	}).catch((error) => {
		onProgressEnd();
		toast.error('Upload Failed', { toastId: createToastId('attachment-failed') });
	});

	event.target.value = null;
};